<template>

  <div>
    <div style="margin: 20px">请在另一台手机上输入以下代码:</div>
    <el-tag type="success" style="margin: 20px">{{ this.getToken() }}</el-tag>
    <el-button plain @click="copy">点击复制</el-button>
  </div>


</template>

<script>
import axios from '@/utils/request'
import {setToken, getToken} from '@/utils/auth'

export default {
  name: 'Home',
  data() {
    return {}
  },
  methods: {
    getToken() {
      return getToken()
    },

    copy() {
      var _input = document.createElement("input");   // 直接构建input
      _input.value = getToken();  // 设置内容
      document.body.appendChild(_input);    // 添加临时实例
      _input.select();   // 选择实例内容
      document.execCommand("Copy");   // 执行复制
      this.$notify({
        type: 'success',
        message: '复制成功',
        duration: 2 * 1000,
        position: "bottom-right"
      })
      document.body.removeChild(_input); // 删除临时实例
    }

  },
  mounted() {

  },
  created() {

  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
